import {IText} from "../../interface";

export const MainContentText : IText = {
    title : "новый",
    title1 : "уровень",
    title2 : "в управлении",
    title3 : "Аэропортом",
    text : 'Повышаем уровень экономики аэропорта за счет автоматизации процессов управления и контроля наземных служб',
}